import React from "react";

interface ShimmerProps {
  children: React.ReactNode;
  isActive: boolean;
  className?: string;
}

/**
 * Shimmer component that animates a linear gradient across the text.
 *
 * Usage:
 * <Shimmer isActive={true}>
 *   <span>Hello, world!</span>
 * </Shimmer>
 */
export default function Shimmer({
  children,
  isActive,
  className = "",
}: ShimmerProps) {
  return (
    <>
      {/* TODO(Aakash): Move this to globals.css or Tailwind config */}
      <style jsx>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
        .text-shimmer {
          background: linear-gradient(
            90deg,
            var(--cdl-fg-muted) 35%,
            var(--cdl-fg-base) 50%,
            var(--cdl-fg-muted) 65%
          );
          background-size: 200% 100%;
          animation: shimmer 2.8s infinite;
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
      `}</style>
      <span
        className={`${
          isActive ? "text-shimmer" : "text-fg-muted"
        } ${className}`}
      >
        {children}
      </span>
    </>
  );
}
